import { useRoutes } from 'react-router-dom';
import router from 'src/router';
import authRoutes from './auth.router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { useAtom } from 'jotai';
import { authorizationAtom } from './store/auth-atom';
import { ErrorBoundary } from 'react-error-boundary';
import Status500 from './content/pages/Status/Status500';

const client = new QueryClient();

function App() {
  const [isAuth] = useAtom(authorizationAtom);
  const content = useRoutes(isAuth ? router : authRoutes);

  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <ErrorBoundary fallback={<Status500 />}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <CssBaseline />
            {content}
            <Toaster position="top-center" />
          </LocalizationProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
export default App;
